module.exports = __webpack_public_path__ + "img/rutv.d8a1c449.svg";